<template>
  <div id="app">
    <div v-if="load_show">
      <load></load>
    </div>
    <headertop style="z-index:999"></headertop>
    <div class="main"style="z-index:999">

      <!-- 导航 -->
      <el-col id="height1" :span="5"  >
        <el-menu default-active="2" class="el-menu-vertical-demo" :unique-opened="true" style="overflow-y: auto;">
          <!-- <h1 class="center" v-if="show.table==0">药知课程</h1> -->
          <el-menu-item class="center" style="width: 100%;" v-if="show.table==0">
            <router-link style="text-decoration: none;"  to="coursemap?num=0">课程地图</router-link>
          </el-menu-item>

          <!-- <h1 class="center" v-if="show.table==1">内部课程</h1> -->
          <div style="height: calc(65vh); overflow: auto;width: 100%;">
            <el-menu-item class="center" index="0" @click="change_show('all')">全部课程</el-menu-item>
            <el-submenu v-for="(val,key) in type_list" :key="'type_'+val.type" :index="val.type+''" >
              <template slot="title">
                <i class="el-icon-folder-opened"></i>
                <span v-on:click="check_type($event,val.type)">
                  {{val.name}}[{{val.count}}]
                </span>
              </template>
              <el-menu-item-group v-for="(val_c,key_c) in val.child" :key="'type_'+val_c.type">
                <el-menu-item :index="val_c.type+''" @click="change_show(val_c.type)">{{val_c.name}}[{{val_c.count}}]</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </div>
        </el-menu>
      </el-col>
      <!-- 课程 -->
      <el-col id="height2" class="right" :span="19">
        <!-- 面包屑-->
        <el-row style="padding-right: 3rem; margin-bottom: 1rem;">
          <!-- <el-breadcrumb separator="/" style="width: 50%;float: left;">
            <el-breadcrumb-item v-for="item in show.address" :key="item.name">
              {{item.name}}
            </el-breadcrumb-item>
          </el-breadcrumb> -->
          <!-- <el-input placeholder="名称、讲师、级别"  v-model="search" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 30%; float:right;margin-top: 20px; " ></el-input> -->
        </el-row>
        <div ref="screen_all" >
        <el-row style="width: 100%;margin-top: 20px; padding-top: 0.625rem; padding-right: 1.875rem; ">
          <el-row v-if="show.table==0">
            <el-col :span="12" >
              <router-link to="Opencourses_tow?type=0" target="_blank" title="若无法正常显示,请删除浏览器历史记录">新版本</router-link>
              <!-- <router-link to="Opencourses_tow?type=0" target="_blank">新版本</router-link> -->
              <span style="text-align: center;" >
                <el-button type="primary" style="margin-right: 1.25rem;" v-if="all_search.type!='video'" size="mini" @click="search_click()">
                  <i class="el-icon-caret-left"></i>
                  视 频</el-button>
                <el-input placeholder="知识点搜索"  v-model="all_search.input" @keyup.enter.native="all_search_click()" style="width: 60%; " prefix-icon="el-icon-search"    ></el-input>
              </span>

            </el-col>
            <el-col :span="12">
              <span  v-if="all_search.type=='video'" style="display: flex;">
                <el-input placeholder="名称、讲师、级别"  v-model="search" @keyup.enter.native="search_click()" style="width: 80%; " prefix-icon="el-icon-search"    ></el-input>
                <el-menu v-if="show.table==0" :default-active="activeIndex" class="el-menu-demo"  mode="horizontal" style="margin-top: -10px">
                  <el-submenu index="2">
                    <template slot="title"style="font-size: 20%;">
                      <span style="color: #409EFF;">课程筛选</span>
                      </template>
                    <el-row>
                      <el-row :style="{width:screen_list.screen_w,height:screen_list.screen_h}" class="shaixuan" >
                        <el-row v-for="item in screen_list.list"  :key="item.num">
                          <el-col style="margin: 0.625rem 0;">
                            {{item.name}}:
                          </el-col>
                          <el-col >
                            <el-tag

                             @click="screen(item_i,item)"  :id="item_i.num+'screen'" style="margin:0.625rem 0.625rem; cursor: pointer; background-color: white;"  v-for="item_i in item.child"  :key="item_i.num">{{item_i.item_name}}</el-tag>
                          </el-col>
                        </el-row>
                        <el-row style="display: flex;justify-content: right;margin-top: 1.25rem;">
                               <el-button type="primary" round @click="search_b('determine')">筛选</el-button>
                        </el-row>
                      </el-row>
                    </el-row>
                  </el-submenu>
                </el-menu>
              </span>
            </el-col>
          </el-row>
          <el-row style="display: flex;justify-content: right;" v-else>
              <span  v-if="all_search.type=='video'" style="display: flex;">
                <el-menu v-if="show.table==0" :default-active="activeIndex" class="el-menu-demo"  mode="horizontal" style="margin-top: -10px">
                  <el-submenu index="2">
                    <template slot="title"style="font-size: 20%;">
                      <span style="color: #409EFF;">高级筛选</span>
                      </template>
                    <el-row>
                      <el-row :style="{width:screen_list.screen_w,height:screen_list.screen_h}" class="shaixuan" >
                        <el-row v-for="item in screen_list.list"  :key="item.num">
                          <el-col style="margin: 0.625rem 0;">
                            {{item.name}}:
                          </el-col>
                          <el-col >
                            <el-tag
                             @click="screen(item_i,item)"  :id="item_i.num+'screen'" style="margin:0.625rem 0.625rem; cursor: pointer; background-color: white;"  v-for="item_i in item.child"  :key="item_i.num">{{item_i.item_name}}</el-tag>
                          </el-col>
                        </el-row>
                        <el-row style="display: flex;justify-content: right;margin-top: 1.25rem;">
                               <el-button type="primary" round @click="search_b('determine')">筛选</el-button>
                        </el-row>
                      </el-row>
                    </el-row>
                  </el-submenu>
                </el-menu>
                <el-input placeholder="名称、讲师、级别"  v-model="search" @keyup.enter.native="search_click()" style="width: 80%; " prefix-icon="el-icon-search"    ></el-input>
              </span>
          </el-row>





        </el-row>
       </div>
        <!-- 卡片-->
        <el-row id="text11" v-if="all_search.type=='video'">
          <el-col class="eachc" v-for="item in show.list" :key="item.num">
            <router-link :to="{path:'/courseplay',query:{num:item.num,type:show.table,resource:show.resource_type}}" >
            <el-card :body-style="{ padding: '10px' }">
              <div class="imgh">
                <img v-if="item.img=='/uploads/company/video/default.jpg'" :src="'https://edu.zhiyaozhishi.com'+item.img"
                                  class="image">
                <img v-else :src="item.img"
                  class="image">
              </div>
              <div style="padding: 5px;" >
                <p style="margin: 0;font-size: x-small;" v-if="show.resource_type=='l'">[{{item.identifier}}]</p>
                 <h6 style="margin: 0;height: 35px;overflow: hidden;"> {{item.name}}</h6>
                <el-row v-if="show.table==0 && item.tag.length>0">
                  <el-col :span="3" :offset="1"  v-for="(i_tag,tag) in item.tag" :key="i_tag"  >
                    <el-tag :type="tag_list[tag].type" v-if="tag<5">{{ item.tag[tag]}}</el-tag>
                  </el-col>
                </el-row>
                <el-row v-else style="height: 2rem;width: 100%;">
                </el-row>
                <div class="bottom clearfix">
                  <h6 style="margin: 0;" class="left">{{item.u_time}}</h6>
                  <h6 style="margin: 0;" class="right">{{item.teacher}}</h6>
                </div>

              </div>
            </el-card></router-link>
          </el-col>
        </el-row>
        <el-row v-else style="margin-top: 1.25rem;">
          <el-row style="height: calc(65vh); overflow: auto;" v-if="all_search.list.length>0">
            <div v-for="(item,index) in all_search.list" :key="index" style=" text-decoration: none;" @click="see_video(item)">
              <el-row style="color: rgb(0, 66, 162);cursor: pointer;font-size: 0.9375rem;padding: 0.3125rem;letter-spacing: 0.125rem">
                {{item.name}}
              </el-row>
              <el-row style="margin: 0.625rem 0;border: 1px solid #ccc;padding: 0.625rem 0.9375rem;letter-spacing: 0.25rem;">
                 {{item.content}}
              </el-row>
            </div>
          </el-row>
          <el-row v-else style="height:calc(65vh) ; display: flex;justify-content: center;align-items: center;">
            <p>未找到您要查询的内容，请重新搜索哦</p>
          </el-row>

        </el-row>
        <br />
        <!-- 分页 -->
        <div class="block center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="show.currentPage" :page-sizes="[6, 9, 24, 48]" :page-size="show.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="show.total">
          </el-pagination>
        </div>
        <br />
      </el-col>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import load from '../../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        tag_list:[{type:''},{type:'success'},{type:'info'},{type:'warning'},{type:'danger'},],
        load_show:false,
        all_search:{
          input:'',
          list:[],
          type:'video'
        },
        type_list:[],
        screen_list:{
          screen_w:'',//宽度
          screen_h:'',
          user_list:[],
          list:[],
        },
        show:{
          list:[],
          tag:'',
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 6,
          table:this.$route.query.type,
          type:'all',
          resource_type:'v',
          address:[]
        },
        search:'',
        activeIndex: '2',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted:function(){
      this.get_tag()
      this.get_type(this.show.table)
      this.get_video('all')
      this.screen_list.screen_w=this.$refs.screen_all.offsetWidth*0.5+'px'
      this.screen_list.screen_h=window.innerHeight*0.6+'px'
    },
    watch:{
      $route(to,from){
        this.show.table=to.query.type
        this.get_type(to.query.type)
        this.get_tag()
        this.get_video('all')
      }
    },
    methods: {
      see_video(item){
        this.$router.push({path:'/courseplay',query:{num:item.num,type:'0',resource:'v'}})
      },
      all_search_click(){
        let _this=this
        _this.all_search.type='selest'
        if(_this.all_search.input==''){
          _this.$message.error('搜索内容不能为空哦！')
          return
        }
        _this.show.currentPage=1
        // _this.show.total=0
        _this.show.pageSize=6
        _this.all_search_video()
      },
      all_search_video(){
        let _this=this
        _this.load_show=true
        _this.axios.get('/v2/user_resource/video_sign_search',{params:{page:_this.show.currentPage,limit:_this.show.pageSize,key:_this.all_search.input}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.all_search.list=res.data.data.data
              _this.show.total=res.data.data.total
            }else{
              _this.$message.error(res.data.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.load_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        });
      },
      get_tag(){
        let _this=this
        if(_this.$route.query.type==0){
          _this.axios.get('/v2/user_resource/get_tag').then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.screen_list.list=res.data.data
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }
      },
      search_b(type){
        this.show.tag=this.screen_list.user_list.join(',')
        this.get_video(this.show.type)
      },
      screen(item,item_all){
        if(item.type==true){
          item.type=false
          document.getElementById(item.num+'screen').style.background="white"
          document.getElementById(item.num+'screen').style.color="#409EFF"
          document.getElementById(item.num+'screen').style.border="1px solid #d9ecff"
        }else{
          for(let i=0;i<item_all.child.length;i++){
            item_all.child[i].type=false
            document.getElementById(item_all.child[i].num+'screen').style.background="white"
            document.getElementById(item_all.child[i].num+'screen').style.color="#409EFF"
            document.getElementById(item_all.child[i].num+'screen').style.border="1px solid #d9ecff"
          }
          document.getElementById(item.num+'screen').style.background="#ecf5ff"

          item.type=true
        }
        for(let i=0;i<this.screen_list.list.length;i++){
          if(item_all.num==this.screen_list.list[i].num){
            if(item.type==false){
              this.screen_list.user_list[i]=''
            }else{
              this.screen_list.user_list[i]=item.num
            }
          }
        }
      },
      search_click(){
        this.all_search.input=''
        this.all_search.type='video'
        this.show.currentPage=1
        this.show.pageSize=6
        this.get_video('all')
      },
      get_type(type){
        let _this=this;
        _this.axios.get('/v2/user_resource/get_type',{params:{type:type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_video(type){
        let _this=this;
        if(type!='' && type!=_this.show.type){
          _this.show.currentPage=1
          _this.show.total=0
          _this.show.pageSize=6
          _this.show.type=type
        }
        _this.axios.get('/v2/user_resource/get_video',{params:{tag:_this.show.tag,type:_this.show.type,table:_this.show.table,page:_this.show.currentPage,limit:_this.show.pageSize,'keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.show.resource_type=res.data.data.resource_type
               _this.show.address=res.data.data.address
              if(res.data.data.list.hasOwnProperty('data')){
                _this.show.list=res.data.data.list.data
                _this.show.total=res.data.data.list.total
                _this.show.currentPage=res.data.data.list.current_page
              }else{
                _this.show.list=[]
                _this.show.total=0
                _this.show.currentPage=1
              }
              for(let i=0;i<_this.screen_list.list.length;i++){
                for(let j=0;j<_this.screen_list.list[i].child.length;j++){
                  if(_this.screen_list.list[i].child[j].type==true){
                    document.getElementById(_this.screen_list.list[i].child[j].num+'screen').style.color="red"
                    document.getElementById(_this.screen_list.list[i].child[j].num+'screen').style.border="1px solid red"
                  }
                }
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
        if(type!='' && type!=_this.show.type){
          _this.screen_list.user_list=[]
          _this.show.tag=''
        }
      },
      change_show(type){
        this.search=''
        this.get_video(type)
      },
      check_type(event,type){
        let _this=this
        if(event.currentTarget.parentElement.nextElementSibling.childElementCount==0){
          _this.get_video(type)
        }
      },
      handleSizeChange(val) {
        this.show.currentPage = 1
        this.show.pageSize = val
        if(this.all_search.type=='video'){
          this.get_video('')
        }else{
          this.all_search_video()
        }
      },
      handleCurrentChange(val) {
        this.show.currentPage = val
        if(this.all_search.type=='video'){
          this.get_video('')
        }else{
          this.all_search_video()
        }

      },
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank');
      },
    },

  }
</script>

<style scoped>
  .tag_true{
    background-color: #ecf5ff;
  }
  .tag_flast{
    background-color: white;
  }
  .shaixuan{
    overflow-y: auto;
  }
 >>> .el-col>.el-menu[data-v-1b536c89]{
    min-height:0;

  }
  .main {
    min-height: calc(100vh - 290px);
    width: 70%;
    padding: 0;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;

  }

  h1 {
    /* color: white; */
    margin: 20px;
  }

  /* 导航 */
  .el-col>.el-menu {
    min-height: calc(100vh - 290px);
    overflow: hidden;
    padding: 20px 0;
    width: 100%;
  }

.el-menu--inline,
.el-menu-item-group>ul
.el-menu-item-group>ul>li{
    width: 100% !important;
  }

.el-menu-item-group__title {
    margin: 0;
    padding: 0;
  }

  #height1>i {
    /* color: white; */
  }

.el-submenu__title {
    width: 100%;
    height: 40px;
    min-height: 40px;
    line-height: 40px;
    font-weight: 600;
    padding: 0 !important;
  }

.el-icon-arrow-down{
    right: 0 !important;
  }
#height1>.el-submenu__title>span,
#height1>.el-menu-item {
    width: 100% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: normal !important;
  }

  .el-submenu {
    width: 100%;
    /* margin-bottom: 20px; */
  }
/* 面包屑 */
.el-breadcrumb{
  margin: 35px;
}
  /* 卡片 */
  .el-row {
    width: 98%;
    padding-left: 2%;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }

  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .eachc {
    margin: 10px;
    width: calc(33% - 20px);
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  #height1 {
    /* background-color: rgb(51, 99, 151); */
    border-right: 2px dashed rgb(51, 99, 151);
    padding: 20px;

  }
     .el-menu{
       border: none;
     }
#text11 a{
  text-decoration:none;
}

.el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
    padding: 0 45px;
    min-width: 200px;
}
.router-link-active {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/view/index/Courses/Opencourses.vue